import {useEffect} from 'react';
import {useSelector} from 'react-redux';

import iccTimeouts from '../../../consts/config/iccTimeouts';
import iccMarketService from '../../../services/icc/iccMarketService';
import {selectAggregatedSettings} from '../../../state/selectors/consumerAggregatedSettings';

let interval;

const ConsumerSettingsChecker = () => {
    const aggregatedSettings = useSelector(selectAggregatedSettings);
    const isAggregatedSettings = !!aggregatedSettings;

    useEffect(() => {
        if (isAggregatedSettings) {
            const {allMandatoryTermsApproved, allNonMandatoryTermsReviewed, settingsRefreshTimeoutSec} =
                aggregatedSettings;

            if (allMandatoryTermsApproved && allNonMandatoryTermsReviewed) {
                const settingsRefreshTimeout = settingsRefreshTimeoutSec
                    ? settingsRefreshTimeoutSec
                    : iccTimeouts.ICC_AGGREGATED_SETTINGS_REFRESH_TIMEOUT;

                clearInterval(interval);
                interval = setInterval(async () => {
                    await iccMarketService.getConsumerAggregatedSettings(false);
                }, settingsRefreshTimeout * 1000);
            }
        }

        return () => clearInterval(interval);
    }, [isAggregatedSettings]);

    return null;
};

export default ConsumerSettingsChecker;
